import React, { useEffect, useState } from 'react';
import { tablePaginationValues } from './listTableHelpers';
import { useSelector } from 'react-redux';
import { selectUpdateMyDocumentsListSubjectId } from 'reducers/misc';

type Props = {
    listUrl: string;
    infoListData?: any;
    loadInfoTableList: (listUrl: string, paramsArr?: any) => void;
};

export const ListPagination2: React.FC<Props> = ({
    listUrl,
    infoListData,
    loadInfoTableList
}) => {
    const updateListSubjectId: number | null = useSelector(selectUpdateMyDocumentsListSubjectId);

    const [additionalPageChangeInfo, setAdditionalPageChangeInfo] = useState<any>(null);

    const { 
        pageNumber,
        pageSize,
        resultsCount,
        totalPages, 
        totalPagesArray,
        ddValArr, 
        itemNumStart, 
        itemNumEnd, 
        previousBtnsInactive, 
        nextBtnsInactive,
        pageSizeViaDropdown, 
        goToPageViaInput,
        goToFirstPage,
        goToPreviousPage,
        goToNextPage,
        goToLastPage,
        goToSelectedPage
    } = tablePaginationValues(infoListData, listUrl, loadInfoTableList);

    useEffect(() => {
        if(resultsCount <= 0 && pageNumber > 1){
            goToPreviousPage();
        }
    }, [pageNumber, resultsCount]);  

    useEffect(() => {
        if(updateListSubjectId){
            setAdditionalPageChangeInfo([{ param: 'subjectsId', value: updateListSubjectId }]);
        }
    }, [updateListSubjectId]);      

    

    return (
        <React.Fragment>
            {infoListData && 
                <div className="TableNavigation">
                    <div className="PaginatonButtons V2">
                        <div className="PaginationButtonsLeft">
                            {!previousBtnsInactive &&
                                <div className="PaginatorBtn2" onClick={() => goToPreviousPage(additionalPageChangeInfo)}>Previous</div>
                            }
                        </div>
                        {totalPagesArray && totalPagesArray.length > 0 &&
                            <div className="PageNumber">
                                {totalPagesArray.map((current_page_num: number) => {
                                    return (
                                        <div 
                                            className={"PageNumBlock" + (current_page_num === pageNumber ? " Current" : "")}
                                            onClick={() => {
                                                if(current_page_num !== pageNumber){
                                                    goToSelectedPage(current_page_num, additionalPageChangeInfo);
                                                }
                                            }}
                                        >
                                            {current_page_num}
                                        </div>
                                    );
                                })}
                            </div>                        
                        }
                        <div className="PaginationButtonsRight">
                            {!nextBtnsInactive &&
                                <div className="PaginatorBtn2" onClick={() => goToNextPage(additionalPageChangeInfo)}>Next</div>
                            }
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};